export default __webpack_public_path__ + "static/media/cc2021 (3).b387e586.jpg";